export enum DOCUMENT_UPLOAD_STATUS_ID {
	CREATED = 'CREATED',
	IN_PROGRESS = 'IN_PROGRESS',
	COMPLETE = 'COMPLETE',
}

export type PresignedUploadModelGeneric = {
	accessUrl: string;
	contentType: string;
	expirationTimestamp: string;
	expirationTimestampDescription: string;
	fileId: string;
	httpHeaders: Record<string, string>;
	httpMethod: string;
	url: string;
};

export type PresignedUploadModel = PresignedUploadModelGeneric;
export type BlogPresignedUploadModel = PresignedUploadModelGeneric;

export enum AssetDisplayTypeId {
	ATTACHMENT = 'ATTACHMENT',
	HERO = 'HERO',
	INLINE = 'INLINE',
}

export interface PresignedUploadRequestModel {
	associatedRecordId: string;
	fileName: string;
	fileType: string;
	fileId: string;
	fileSize: number;
	assetDisplayTypeId: AssetDisplayTypeId;
}
